// Rules of an event, materialized from its process template (EventResponse/EventDetailResponse/
// ProcessEventDto/AssignableEventDto/RegistrationResponse carry the flags; label and icon come from the
// template).
export function eventRules(evt) {
  return {
    linkSignup: !!evt?.linkSignup,
    neverPublic: !!evt?.neverPublic,
    requiresLeader: !!evt?.requiresLeader,
    prepaymentRequired: !!evt?.prepaymentRequired,
    eventLabel: evt?.eventLabel || null,
    icon: evt?.processTemplateIcon || null,
    templateName: evt?.processTemplateName ?? null,
  };
}

// Private sign-up link (lock badge, "Einladungslink" section).
export const hasLinkSignup = (evt) => eventRules(evt).linkSignup;
export const isNeverPublic = (evt) => eventRules(evt).neverPublic;
export const eventLabelOf = (evt) => eventRules(evt).eventLabel;
